var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "head_box flex_space flex_center_align",
        on: {
          click: function ($event) {
            _vm.fold = !_vm.fold
          },
        },
      },
      [
        _c(
          "div",
          { staticClass: "flex_start flex_center_align" },
          [
            _c("svg-icon", { attrs: { "icon-class": "edit_2_line" } }),
            _c("span", { staticClass: "hd_title" }, [_vm._t("title")], 2),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "arrow_box flex_center_align flex_center" },
          [
            _c("svg-icon", {
              staticClass: "arrow_svg",
              class: { rote: _vm.fold },
              attrs: { "icon-class": "up_line" },
            }),
          ],
          1
        ),
      ]
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.fold,
            expression: "!fold",
          },
        ],
        staticClass: "file_box m20",
      },
      [
        _c(
          "vab-row",
          { staticClass: "row_box gray" },
          [
            _c("vab-col", { staticClass: "boxleft ht", attrs: { span: 8 } }, [
              _vm._v("工事部"),
            ]),
            _c("vab-col", { staticClass: "boxleft ht", attrs: { span: 8 } }, [
              _vm._v("LC"),
            ]),
            _c("vab-col", { staticClass: "boxleft ht", attrs: { span: 8 } }, [
              _vm._v("PS課"),
            ]),
          ],
          1
        ),
        _c(
          "vab-row",
          { staticClass: "row_box" },
          [
            _c(
              "vab-col",
              {
                staticClass: "boxleft flex_colum",
                class: { gray: _vm.type < 2 },
                attrs: { span: 8 },
              },
              [
                _vm.type > 2
                  ? [
                      _c("div", { staticClass: "gcs_item flex_colum" }, [
                        _c("div", { staticClass: "gcs_title" }, [
                          _vm._v("【工事中の実施可否】"),
                        ]),
                        _c("div", { staticClass: "gcs_title" }, [
                          _vm._v("予定通り実施"),
                        ]),
                      ]),
                      _c("div", { staticClass: "gcs_item flex_colum" }, [
                        _c("div", { staticClass: "gcs_title" }, [
                          _vm._v("【コメント】"),
                        ]),
                        _c("div", { staticClass: "gcs_title" }, [
                          _vm._v("よろしくお願いいたします。"),
                        ]),
                      ]),
                    ]
                  : [
                      _c("vab-select", {
                        attrs: {
                          label: "工事中の実施可否",
                          "label-width": "150px",
                          prop: "gszkf",
                          "data-key": "gszkfcont",
                          "label-id": "label",
                          "value-id": "value",
                          "data-type": "local",
                          validate: "required",
                          disabled: _vm.type < 2,
                          clearable: "",
                        },
                      }),
                      _c("vab-textarea", {
                        attrs: {
                          label: "コメント",
                          prop: "JCInfoData.constructionRecordMemo",
                          rows: 4,
                          disabled: _vm.type < 2,
                        },
                      }),
                    ],
              ],
              2
            ),
            _c(
              "vab-col",
              {
                staticClass: "boxleft flex_colum",
                class: { gray: _vm.type < 3 },
                attrs: { span: 8 },
              },
              [
                _vm.type > 3
                  ? [
                      _c("div", { staticClass: "gcs_item flex_colum" }, [
                        _c("div", { staticClass: "gcs_title" }, [
                          _vm._v("【実施判断】"),
                        ]),
                        _c("div", { staticClass: "gcs_title" }, [
                          _vm._v("予定通り実施"),
                        ]),
                      ]),
                      _c("div", { staticClass: "gcs_item flex_colum" }, [
                        _c("div", { staticClass: "gcs_title" }, [
                          _vm._v("【実施月】"),
                        ]),
                        _c("div", { staticClass: "gcs_title" }, [
                          _vm._v("設定月以外でも可能"),
                        ]),
                      ]),
                      _c("div", { staticClass: "gcs_item flex_colum" }, [
                        _c("div", { staticClass: "gcs_title" }, [
                          _vm._v("【同日実施】"),
                        ]),
                        _c("div", { staticClass: "gcs_title" }, [
                          _vm._v("ずらさない"),
                        ]),
                      ]),
                      _c("div", { staticClass: "gcs_item flex_colum" }, [
                        _c("div", { staticClass: "gcs_title" }, [
                          _vm._v("【点検実施範囲】"),
                        ]),
                        _c("div", { staticClass: "gcs_title" }, [
                          _vm._v("縮小または変更"),
                        ]),
                      ]),
                      _c("div", { staticClass: "gcs_item flex_colum" }, [
                        _c("div", { staticClass: "gcs_title" }, [
                          _vm._v("【コメント】"),
                        ]),
                        _c("div", { staticClass: "gcs_title" }, [
                          _vm._v("よろしくお願いいたします。"),
                        ]),
                      ]),
                    ]
                  : [
                      _c("vab-select", {
                        attrs: {
                          label: "実施判断",
                          "label-width": "150px",
                          prop: "sspd",
                          "data-key": "sspdconst",
                          "label-id": "label",
                          "value-id": "value",
                          "data-type": "local",
                          validate: "required",
                          clearable: "",
                          disabled: _vm.type < 3,
                        },
                      }),
                      _c("vab-select", {
                        attrs: {
                          label: "実施月",
                          "label-width": "150px",
                          prop: "ssy",
                          "data-key": "ssyconst",
                          "label-id": "label",
                          "value-id": "value",
                          "data-type": "local",
                          validate: "required",
                          clearable: "",
                          disabled: _vm.type < 3,
                        },
                      }),
                      _c("vab-select", {
                        attrs: {
                          label: "工事中の実施可否",
                          "label-width": "150px",
                          prop: "gskf",
                          "data-key": "gszkfcont",
                          "label-id": "label",
                          "value-id": "value",
                          "data-type": "local",
                          validate: "required",
                          clearable: "",
                          disabled: _vm.type < 3,
                        },
                      }),
                      _c("vab-textarea", {
                        attrs: {
                          label: "コメント",
                          prop: "JCInfoData.constructionRecordMemo",
                          rows: 4,
                          disabled: _vm.type < 3,
                        },
                      }),
                    ],
              ],
              2
            ),
            _c(
              "vab-col",
              {
                staticClass: "boxleft flex_colum",
                class: { gray: _vm.type < 4 },
                attrs: { span: 8 },
              },
              [
                _vm.type > 4
                  ? [
                      _c("div", { staticClass: "gcs_item flex_colum" }, [
                        _c("div", { staticClass: "gcs_title" }, [
                          _vm._v("【作業月の変更】"),
                        ]),
                        _c("div", { staticClass: "gcs_title" }, [
                          _vm._v("なし"),
                        ]),
                      ]),
                      _c("div", { staticClass: "gcs_item flex_colum" }, [
                        _c("div", { staticClass: "gcs_title" }, [
                          _vm._v("【変更月】"),
                        ]),
                        _c("div", { staticClass: "gcs_title" }, [
                          _vm._v("2022/09"),
                        ]),
                      ]),
                      _c("div", { staticClass: "gcs_item flex_colum" }, [
                        _c("div", { staticClass: "gcs_title" }, [
                          _vm._v("【コメント】"),
                        ]),
                        _c("div", { staticClass: "gcs_title" }, [
                          _vm._v("よろしくお願いいたします。"),
                        ]),
                      ]),
                    ]
                  : [
                      _c("vab-radio-group", {
                        attrs: {
                          prop: "asbestoContainFlg",
                          label: "作業月の変更",
                          "label-width": "150px",
                          "data-type": "local",
                          "data-key": "tzList",
                          "label-id": "name",
                          "value-id": "mode",
                          disabled: _vm.type < 4,
                        },
                      }),
                      _c("vab-date-picker", {
                        attrs: {
                          type: "date",
                          label: "変更月",
                          "value-format": "yyyy/MM/dd",
                          format: "yyyy/MM/dd",
                          prop: "planContractStartDate",
                          disabled: _vm.type < 4,
                        },
                      }),
                      _c("vab-textarea", {
                        attrs: {
                          label: "コメント",
                          prop: "JCInfoData.constructionRecordMemo",
                          rows: 4,
                          disabled: _vm.type < 4,
                        },
                      }),
                    ],
              ],
              2
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }